var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "about-us-arrow-2",
    class: {
      primary: _vm.isPrimary,
      hidden: _vm.isHidden
    }
  }, [_c('div', {
    staticClass: "main-box"
  }, [_c('div', {
    staticClass: "heading-3-bold"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._m(0), _vm._m(1)]), _c('div', {
    staticClass: "arrow"
  })]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "thin-arrow-holder"
  }, [_c('div', {
    staticClass: "branch"
  }), _c('div', {
    staticClass: "branch"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "thin-arrow-holder second"
  }, [_c('div', {
    staticClass: "branch"
  }), _c('div', {
    staticClass: "branch"
  })]);

}]

export { render, staticRenderFns }